import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '@zapier/design-system';
import { COLOR_KEYS, HEADING_SIZE_MAP, mediaQueries, MEDIA_MIN_WIDTH, SUB_HEADING_SIZE_MAP, } from '../../constants';
import { isBackgroundStyle, mapBackgroundStyleToColor, isBackgroundImage, getBackgroundImage, } from './background';
const Styles = labelStyles('Section', {
    root: ({ background, contentWidth, }) => [
        isBackgroundStyle(background) &&
            css `
        background-color: ${Colors[mapBackgroundStyleToColor(background)]};
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      `,
        isBackgroundImage(background) &&
            css `
        background-image: url('/l/images/${getBackgroundImage(background)}');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      `,
        !isBackgroundStyle(background) &&
            !isBackgroundImage(background) && // In this case, only apply background color
            css `
        background-color: ${Colors[background]};
      `,
        contentWidth === 'padded' &&
            css `
        label: contentWidth-padded;
        padding: 40px 20px;
        ${mediaQueries.tablet} {
          padding: 60px 30px;
        }
        ${mediaQueries.desktop} {
          padding: 65px 100px;
        }
      `,
        contentWidth === 'fullWidth' &&
            css `
        label: contentWidth-fullWidth;
        padding: 50px 20px;
        ${mediaQueries.tablet} {
          padding: 70px 30px;
        }
      `,
        contentWidth === 'overflow' &&
            css `
        label: contentWidth-overflow;

        padding: 60px 0 60px 20px;
        ${mediaQueries.desktop} {
          padding: 65px 0 65px 30px;
        }
      `,
        contentWidth === 'custom' &&
            css `
        label: contentWidth-custom;
      `,
    ],
    backgroundLayer: ({ background }) => [
        isBackgroundStyle(background) &&
            css `
        align-items: center;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        max-width: 1350px;
        pointer-events: none;
      `,
        (background === 'Lava40Dotty' || background === 'Sun60Dotty') &&
            css `
        background-image: url('/l/images/dotty.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      `,
    ],
    content: css `
    max-width: 1280px;
    margin: 0 auto 0 auto;
  `,
    headingWrapper: css `
    margin-bottom: 40px;
    text-align: center;

    ${mediaQueries.tablet} {
      margin-bottom: 60px;
    }

    ${mediaQueries.desktop} {
      margin-bottom: 70px;
    }
  `,
    heading: ({ background, headingSize, }) => css(Object.assign(Object.assign({ maxWidth: '800px', margin: '0 auto' }, (headingSize
        ? Typography[HEADING_SIZE_MAP[headingSize].mobile]
        : Typography.sectionHeader1)), { color: background === COLOR_KEYS.zapier ||
            background === COLOR_KEYS.night ||
            background === COLOR_KEYS.moss ||
            background === COLOR_KEYS.neutral800 ||
            background === COLOR_KEYS.earth
            ? Colors.neutral100
            : Colors.neutral800, textAlign: 'center', '&:not(:last-child)': { marginBottom: '0.25em' }, [MEDIA_MIN_WIDTH.small]: Object.assign({}, (headingSize
            ? Typography[HEADING_SIZE_MAP[headingSize].tablet]
            : Typography.pageHeader5)), [MEDIA_MIN_WIDTH.large]: Object.assign({}, (headingSize
            ? Typography[HEADING_SIZE_MAP[headingSize].desktop]
            : Typography.pageHeader5)) })),
    subheading: ({ background, headingSize, }) => css(Object.assign(Object.assign({ maxWidth: '800px', margin: '0 auto' }, (headingSize
        ? Typography[SUB_HEADING_SIZE_MAP[headingSize].mobile]
        : Typography.smallPrint1)), { color: background === COLOR_KEYS.zapier ||
            background === COLOR_KEYS.night ||
            background === COLOR_KEYS.moss ||
            background === COLOR_KEYS.neutral800 ||
            background === COLOR_KEYS.earth
            ? Colors.neutral100
            : Colors.neutral800, [MEDIA_MIN_WIDTH.small]: Object.assign({}, (headingSize
            ? Typography[SUB_HEADING_SIZE_MAP[headingSize].tablet]
            : Typography.paragraph1)), [MEDIA_MIN_WIDTH.large]: Object.assign({}, (headingSize
            ? Typography[SUB_HEADING_SIZE_MAP[headingSize].desktop]
            : Typography.paragraph1)) })),
});
export function Section({ background = 'transparent', children, contentWidth = 'padded', heading, headingSize, style = {}, subheading, }) {
    return (_jsxs("div", Object.assign({ css: Styles.root({
            background,
            contentWidth,
        }), style: style }, { children: [_jsx("div", { css: Styles.backgroundLayer({ background }) }), heading && (_jsxs("div", Object.assign({ css: Styles.headingWrapper }, { children: [heading && (_jsx("h2", Object.assign({ css: Styles.heading({ background, headingSize }) }, { children: heading }))), subheading && (_jsx("p", Object.assign({ css: Styles.subheading({ background, headingSize }) }, { children: subheading })))] }))), _jsx("div", Object.assign({ css: Styles.content }, { children: children }))] })));
}
//# sourceMappingURL=Section.js.map